import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useState } from 'react';

const useApiRequest = ({
  apiAction,
  setValueAction,
  clearForm = true,
  defaultValues,
  afterAPICall,
  beforeAPICall,
  setMeta,
  isForm = true,
  clearValueActionOnError,
  successMessage = true,
  errorMessage = true,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { control, handleSubmit, reset, watch, setValue} = useForm({ defaultValues });
  const dispatch = useDispatch();

  const submitHandler = async (data) => {
    
    setIsLoading(true);
    try {
      const before = beforeAPICall ? beforeAPICall(data) : { success: true };
      if (before.success) {
        const result = await dispatch(apiAction(before.refactoredData ? before.refactoredData : data ? data : null));
        if (result?.payload?.success) {
          successMessage && toast.success(result?.payload?.message);
          setValueAction && (await dispatch(setValueAction(result.payload.data)));
          setMeta && (await dispatch(setMeta(result.payload?.meta)));
          clearForm && reset();
          afterAPICall && afterAPICall(result.payload.data);
        } else {
          clearValueActionOnError && (await dispatch(clearValueActionOnError()));
          errorMessage && toast.error(result?.payload?.message);
        }
      } else {
        clearValueActionOnError && (await dispatch(clearValueActionOnError()));
        errorMessage && toast.error(before.message);
      }
    } catch (error) {
      clearValueActionOnError && (await dispatch(clearValueActionOnError()));
      console.error('API Request Error:', error);
      toast.error('An error occurred while making the API request.');
    } finally {
      setIsLoading(false);
    }
  };
  return { isLoading, control, handleSubmit: isForm ? handleSubmit(submitHandler) : submitHandler, watch, setValue };
};

export default useApiRequest;
